import { render } from "./HotAdManageView.vue?vue&type=template&id=fb7a68b2&scoped=true"
import script from "./HotAdManageView.vue?vue&type=script&lang=js"
export * from "./HotAdManageView.vue?vue&type=script&lang=js"

import "./HotAdManageView.vue?vue&type=style&index=0&id=fb7a68b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7a68b2"]])

export default __exports__